module.exports = __webpack_public_path__ + "img/book-closed.804330e6.jpg";